import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default class DateTimeDisplay extends Component {
  static propTypes = {
    present_aware: PropTypes.bool,
    useTimezone: PropTypes.string,
    timestamp: PropTypes.string,
    date_only: PropTypes.bool,
    full_day_name: PropTypes.bool,
    time_only: PropTypes.bool,
    format: PropTypes.string,
    show_timezone: PropTypes.bool,
    separateWithNewLine: PropTypes.bool,
    timestampFormat: PropTypes.string,
  };

  static defaultProps = {
    timestampFormat: 'MMMM D [at] h:mm A z',
    present_aware: true,
    show_timezone: true,
    useTimezone: moment.tz.guess(),
    separateWithNewLine: false,
  };

  renderedDate() {
    const sameDay = moment()
      .tz(this.props.useTimezone)
      .isSame(this.props.timestamp, 'day');
    const yesterday = moment()
      .tz(this.props.useTimezone)
      .subtract(1, 'days')
      .isSame(this.props.timestamp, 'day');

    if (this.props.present_aware && sameDay) {
      return 'Today';
    } else if (this.props.present_aware && yesterday) {
      return 'Yesterday';
    }
    if (this.props.full_day_name) {
      return moment(this.props.timestamp)
        .tz(this.props.useTimezone)
        .format('dddd, MMM D YYYY');
    }
    return moment(this.props.timestamp)
      .tz(this.props.useTimezone)
      .format('MMMM D, YYYY');
  }

  renderedTime() {
    return moment(this.props.timestamp)
      .tz(this.props.useTimezone)
      .format(`h:mm A${this.props.show_timezone ? ' z' : ''}`);
  }

  render() {
    let firstPart = null;
    let secondPart = null;
    let separator = null;

    if (this.props.format) {
      firstPart = moment(this.props.timestamp)
        .tz(this.props.useTimezone)
        .format(this.props.format);
    } else if (this.props.date_only) {
      firstPart = this.renderedDate();
    } else if (this.props.time_only) {
      firstPart = this.renderedTime();
    } else {
      firstPart = this.renderedDate();
      separator = this.props.separateWithNewLine ? <br></br> : <span>&nbsp;</span>;
      secondPart = this.renderedTime();
    }
    return (
      <span title={moment(this.props.timestamp).tz(this.props.useTimezone).format(this.props.timestampFormat)}>
        {firstPart}
        {separator}
        {secondPart}
      </span>
    );
  }
}
